export enum ShareType {
  /** 全员共享 */
  All = 1,
  /** 不共享 */
  None = 2,
  /**部分共享 */
  Part = 3,
}

export enum MonitorType {
  Shop = 1,
  Goods = 2,
}

export enum ActionStatus {
  // 查看详情
  View = 2,
  // 咨询商家
  Consult = 3,
}

export enum popStatus {
  Yes = 1,
  No = 2,
}
